import { cookies as documentCookies } from '@catalogo/core-cookies';
import query from './cookies.graphql';

export const setCookies = (cache, req) => {
  const cookies = req ? req.cookies : documentCookies.getAll();

  cache.writeQuery({
    query,
    data: { cookies },
  });
};
